<template>
  <a-card>
    <CardView
      title="企业基本信息"
      :schema="baseSchema"
      :sourceData="baseSourceData"
    ></CardView>
    <a-divider />
    <CardView
      title="企业额外信息"
      :schema="extraSchema"
      :sourceData="extraSourceData"
    ></CardView>
    <a-divider />
    <a-row type="flex" justify="center">
      <a-button
        v-if="this.$route.params.backType == 2"
        @click="$router.push({ name: 'blacklist' })"
        class="margin-right-20"
      >
        返回列表
      </a-button>
      <a-button
        v-if="this.$route.params.backType == 1"
        @click="$router.push({ name: 'client-center' })"
        class="margin-right-20"
      >
        返回列表
      </a-button>
      <a-button type="primary" @click="handleClick" v-if="isAdmin">移出黑名单</a-button>
    </a-row>
  </a-card>
</template>

<script>
import { CardView } from 'lxfintech-fe'
import mixin from './mixin'
import { getDetails, removedBlacklist,checkIsAdmin } from '../api'
import { ERR_OK } from '@/config'

export default {
  components: { CardView },
  mixins: [mixin],
  mounted() {
    this._getDetails()
    this._checkIsAdmin()
  },
  data() {
    return {
      loading: false,
      isAdmin: false,   //判断是否管理员角色
    }
  },
  methods: {
    // 检查是否为系统管理员角色
    async _checkIsAdmin() {
      const { code, data } = await checkIsAdmin()
      if (code === ERR_OK) {
        this.isAdmin = data.roleAdmin
      }
    },
    _getDetails() {
      // const { id } = this.$route.params.id
      getDetails(this.$route.params.id).then(({ data: { base, detail } }) => {
        this.baseSourceData = base
        this.extraSourceData = detail
      })
    },
    handleClick() {
      this.$confirm({
        title: '提示',
        content: '是否移出黑名单?',
        okButtonProps: {
          loading: this.loading,
        },
        cancelText: '取消',
        okText: '确定',
        onOk: () => {
          this.loading = true
          return this._removedBlacklist()
        },
      })
    },
    _removedBlacklist() {
      // const { id } = this.$route.params.id
      return removedBlacklist(this.$route.params.id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        if(this.$route.params.backType == 1){
          this.$router.push({ name: 'client-center' })
        }else{
          this.$router.push({ name: 'blacklist' })
        }
      })
    },
  },
}
</script>
